import { toast } from 'react-toastify';

export class AdminApi {
  static async get(path: string): Promise<any> {
    return await this.request(path, 'GET');
  }

  static async put(path: string, data: any): Promise<any> {
    return await this.request(path, 'PUT', data);
  }

  static async post(path: string, data: any): Promise<any> {
    return await this.request(path, 'POST', data);
  }

  static async delete(path: string): Promise<any> {
    return await this.request(path, 'DELETE');
  }

  private static async request(
    path: string,
    method: string,
    data?: any,
  ): Promise<any> {
    const _data = await fetch(`/api/admin${path}`, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const _result = await _data.json();

    if (_result.message) {
      toast.error(
        Array.isArray(_result.message)
          ? _result.message.join(', ')
          : _result.message,
        {
          autoClose: false,
        },
      );
    }

    return _result.ok ? _result.model : null;
  }
}
